import { NavLink } from "react-router-dom";
import { Home, Store, Heart, ShoppingBag, User } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export default function MobileBottomNav() {
  const { cartCount, wishlist } = useStore();
  const items = [
    { to: "/", icon: Home, label: "Home", testid: "bottomnav-home" },
    { to: "/shop", icon: Store, label: "Shop", testid: "bottomnav-shop" },
    { to: "/wishlist", icon: Heart, label: "Wishlist", badge: wishlist.length, testid: "bottomnav-wishlist" },
    { to: "/cart", icon: ShoppingBag, label: "Cart", badge: cartCount, testid: "bottomnav-cart" },
    { to: "/account", icon: User, label: "Account", testid: "bottomnav-account" },
  ];
  return (
    <nav data-testid="mobile-bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 h-[calc(4rem+env(safe-area-inset-bottom))] pb-[env(safe-area-inset-bottom)] grid grid-cols-5 bg-white/75 backdrop-blur-2xl backdrop-saturate-150 border-t border-white/60 shadow-[0_-8px_24px_-16px_rgba(15,23,42,0.28)]">
      {items.map((it) => (
        <NavLink key={it.to} to={it.to} end={it.to === "/"} data-testid={it.testid}
          className={({ isActive }) => `relative flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors ${isActive ? "text-amber-700" : "text-slate-700"}`}>
          <span className="relative">
            <it.icon className="h-5 w-5" />
            {it.badge > 0 && <span className="absolute -top-1.5 -right-2 h-4 min-w-[16px] px-1 grid place-items-center rounded-full bg-amber-500 text-white text-[9px] font-bold">{it.badge}</span>}
          </span>
          {it.label}
        </NavLink>
      ))}
    </nav>
  );
}
